import React from 'react';
import { motion } from 'framer-motion';
export function Section8() {
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6
  }} viewport={{
    once: true
  }} className="max-w-3xl mx-auto px-6 py-16" data-id="element-208">
      <h2 className="font-sans font-bold text-3xl text-[#0F4226] mb-8" data-id="element-209">
        8. But Wait...
      </h2>

      <div className="font-sans text-lg leading-relaxed text-[#666666] space-y-10" data-id="element-210">
        <div className="bg-white p-8 rounded shadow-md border-t-4 border-[#4DC61A]" data-id="element-211">
          <h3 className="font-sans font-bold text-2xl mb-4 text-[#0F4226]" data-id="element-212">
            "Does it actually work? I've tried natural products before and been
            disappointed."
          </h3>
          <p className="mb-4" data-id="element-213">
            Your disappointment is valid. Those products did fail. But here's
            what's different: this isn't a spray that washes off or a collar
            scent that fades in three weeks. The continuous passive emission is
            what makes FLO categorically different from everything you've tried.
          </p>
          <p className="mb-4" data-id="element-214">
            The ancient methods worked because of{' '}
            <em data-id="element-215">continuous ambient exposure</em> to plant VOCs. Modern sprays
            and herbal collars can't maintain that. FLO's pendant is engineered
            specifically to solve that delivery problem — 24/7 emission at
            consistent concentrations for 12 months.
          </p>
          <p className="font-semibold text-[#0F4226]" data-id="element-216">
            And if it doesn't work for your pet? You pay nothing. 60-day
            guarantee. No questions asked.
          </p>
        </div>

        <div className="bg-white p-8 rounded shadow-md border-t-4 border-[#4DC61A]" data-id="element-217">
          <h3 className="font-sans font-bold text-2xl mb-4 text-[#0F4226]" data-id="element-218">
            "Is it safe for cats? I know some essential oils are toxic to cats."
          </h3>
          <p className="mb-4" data-id="element-219">
            This concern is legitimate and deserves a direct answer. The
            compounds in FLO work through{' '}
            <strong className="text-[#0F4226]" data-id="element-220">airborne VOC emission</strong> —
            not topical application. Your cat isn't licking it off their fur.
            They're not ingesting it. The protection comes from the air around
            them.
          </p>
          <p className="mb-4" data-id="element-221">
            The specific plant compounds used are selected for both efficacy{' '}
            <em data-id="element-222">and</em> feline safety. The octopamine receptor mechanism we
            discussed in Section 5 applies to parasites, not mammals — including
            cats.
          </p>
          <p className="font-semibold text-[#0F4226]" data-id="element-223">
            Over 15,000 cat owners are currently using FLO. Read Rachel's
            testimonial above — she had the same concern you do.
          </p>
        </div>

        <div className="bg-white p-8 rounded shadow-md border-t-4 border-[#4DC61A]" data-id="element-224">
          <h3 className="font-sans font-bold text-2xl mb-4 text-[#0F4226]" data-id="element-225">
            "How does a pendant actually work? It sounds too simple."
          </h3>
          <p className="mb-4" data-id="element-226">
            Simplicity is the point. The ancient methods that worked for 2,000
            years were simple — cedar in the doorway, pennyroyal in the bedding.
            The breakthrough wasn't discovering new chemistry; it was solving
            the delivery problem.
          </p>
          <p className="mb-4" data-id="element-227">
            The pendant makes continuous passive emission possible at scale. It
            clips to your pet's collar and releases plant VOCs that interfere
            with the parasite detection window — the moment when fleas and ticks
            are searching for a host using heat, CO2, and chemical signals.
          </p>
          <p className="font-semibold text-[#0F4226]" data-id="element-228">
            Remember the octopamine receptor science from Section 5? That's
            what's happening, continuously, for 12 months. The simplicity is
            what makes it work.
          </p>
        </div>

        <div className="bg-white p-8 rounded shadow-md border-t-4 border-[#4DC61A]" data-id="element-229">
          <h3 className="font-sans font-bold text-2xl mb-4 text-[#0F4226]" data-id="element-230">
            "$39.99 seems expensive for something unproven to me."
          </h3>
          <p className="mb-4" data-id="element-231">
            Let's reframe against the full cost of alternatives:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-232">
            <li data-id="element-233">Chemical treatments: $100–$200 per year per pet</li>
            <li data-id="element-234">
              Flea infestation remediation: $500–$2,000 (exterminator, cleaning,
              replacement items)
            </li>
            <li data-id="element-235">
              Canine Lyme disease treatment: Starts at $200 for antibiotics, can
              reach thousands in complications
            </li>
            <li data-id="element-236">
              The emotional cost of choosing between effective and safe:
              Priceless
            </li>
          </ul>
          <p className="mb-4" data-id="element-237">
            FLO is $39.99 for 12 months —{' '}
            <strong className="text-[#0F4226]" data-id="element-238">$3.34 per month</strong> — for a
            product backed by a guarantee that eliminates all financial risk.
          </p>
          <p className="font-semibold text-[#0F4226]" data-id="element-239">
            If it doesn't work, you get a full refund. If it does work, you've
            solved a problem you've been struggling with for years for less than
            the cost of a monthly coffee subscription.
          </p>
        </div>
      </div>
    </motion.section>;
}